import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { validateApiResponse } from '~/queries/utils';
import { apiInstance } from '~/utils/api/client';

type Type = 'feature' | 'update' | 'bugfix';

interface Note {
  label: Type;
  // eslint-disable-next-line camelcase
  display_label: string;
  notes: { title: string }[];
}

export interface ReleaseNotesRelease {
  id: string;
  private: 0 | 1;
  title: string;
  url: string;
  type: Type;
  description: string | null;
  notes: Note[];
  owner: {
    name: string;
    avatar: string;
  };
  // eslint-disable-next-line camelcase
  released_at: number;
  // eslint-disable-next-line camelcase
  featured_image: '' | string;
}

interface RecentNotes {
  releases: ReleaseNotesRelease[];
}

const buildAPI = apiInstance({
  url: `https://widget.releasenotes.io/${
    import.meta.env.VITE_RELEASE_NOTES_ACCOUNT
  }/api/v1.1/release`,
});

export const getRecent = (tag = 'control room') =>
  buildAPI.get<RecentNotes, Error>(`/recent.json?tag=${tag}`);

export const getReleaseNotesQueryKey = () => ['releaseNotes'];

export const useReleaseNotesRecentQuery = (
  options?: UseQueryOptions<RecentNotes | undefined, Error, RecentNotes>,
) =>
  useQuery<RecentNotes | undefined, Error, RecentNotes>(
    getReleaseNotesQueryKey(),
    async () => {
      const response = validateApiResponse(await getRecent());
      return response.data;
    },
    options,
  );
